import React from 'react'
import { string, bool } from 'prop-types'

import cgdreamImgSm from 'images/backgrounds/headers/CGDream_sm.jpg'
import cgdreamImgMd from 'images/backgrounds/headers/CGDream_md.jpg'
import cgdreamImgXl from 'images/backgrounds/headers/CGDream_xl.jpg'

import cgdreamGif from 'images/backgrounds/headers/CGDream_dynamic.gif'
import cgdreamGif2 from 'images/backgrounds/headers/CGDream_dynamic.webp'

function WildcatBanner({
  pageName,
  customClass = '',
  title = 'A new kind of freelancing platform for 3D designers',
  subtitle = '',
  benefitsAreHidden = false,
  openInNewTab = false,
  buttonClass = '',
}) {
  if (pageName === 'seller-dashboard') {
    return (
      <a
        href="https://cgdream.ai?utm_source=cgtrader&utm_medium=referral&utm_campaign=profile"
        rel="nofollow noreferrer"
        target="_blank"
      >
        <picture>
          <source
            media="(max-width:576px)"
            srcSet={cgdreamImgSm}
            type="image/jpeg"
          />
          <source
            media="(max-width:964px)"
            srcSet={cgdreamImgMd}
            type="image/jpeg"
          />
          <img
            src={cgdreamImgXl}
            alt="Wildcat banner"
            width="3313"
            height="794"
            className="products-wildcat-banner"
          />
        </picture>
      </a>
    )
  }

  if (pageName === 'free-download') {
    return (
      <a
        href="https://cgdream.ai?utm_source=cgtrader&utm_medium=referral&utm_campaign=download"
        rel="nofollow noreferrer"
        target="_blank"
      >
        <picture>
          <source srcSet={cgdreamGif2} type="image/webp" />
          <img
            src={cgdreamGif}
            alt="Cgdream banner"
            width="960"
            height="494"
            className="products-wildcat-banner dynamic-banner"
          />
        </picture>
      </a>
    )
  }

  return (
    <div
      className={`card card--interactive wildcat-banner wildcat-banner--${pageName} ${customClass}`}
    >
      <a
        href="/freelance-with-us"
        className="banner__link"
        target={openInNewTab ? '_blank' : ''}
      >
        <div className="banner-content">
          <div className="banner__heading">
            <h2 className="banner__title">{title}</h2>
            {subtitle && <div className="banner__subtitle">{subtitle}</div>}
          </div>

          {!benefitsAreHidden && (
            <div className="banner__benefits-list">
              <div className="benefits-list__item">
                - Earn up to $200 per delivered model
              </div>
              <div className="benefits-list__item">
                - Enjoy multiplier bonuses and top rates
              </div>
              <div className="benefits-list__item">
                - Pick the tasks you want, no bidding
              </div>
              <div className="benefits-list__item">
                - A constant stream of work and income
              </div>
            </div>
          )}

          <div className="banner__cta">
            <span
              className={`cgt-button cgt-button--secondary btn-cta-light btn-cta ${buttonClass}`}
            >
              Learn More
            </span>
          </div>
        </div>
      </a>
    </div>
  )
}

WildcatBanner.propTypes = {
  pageName: string.isRequired,
  customClass: string,
  title: string,
  subtitle: string,
  benefitsAreHidden: bool,
  openInNewTab: bool,
  buttonClass: string,
}

export default WildcatBanner
